import React from "react";
import LinkIcon from "../../../assets/icons/track-link-purple-bg.svg";
import ChevronRight from "../../../assets/icons/grey-chevron-right.svg";
import "./index.less";

export type TrackingLinkItemProps = {
  title: string;
  createdAt?: string;
  nbrOfClicks?: number;
  onClick?: () => void;
};

const TrackingLinkItem: React.FC<TrackingLinkItemProps> = ({ title, createdAt, nbrOfClicks = 0, onClick }) => {
  return (
    <div className="tl-row" onClick={onClick} role="button" tabIndex={0}>
      <div className="tl-left">
        <img className="tl-row-icon" src={LinkIcon} alt="icon" />
      </div>
      <div className="tl-row-middle">
        <div className="tl-row-title">{title}</div>
        {createdAt && (
          <div className="tl-row-subline">
            <span className="tl-row-subtitle">{createdAt}</span>
          </div>
        )}
      </div>
      {typeof nbrOfClicks === "number" && <span className="tl-row-count">{nbrOfClicks} clics</span>}
      <img className="tl-row-chevron" src={ChevronRight} alt="chevron" />
    </div>
  );
};

export default TrackingLinkItem;
